import * as React from 'react'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'
import { isMobile } from '../../../utilities/userAgent'
import NccShareComplete from './steps/NccShareComplete'
import NccShareReview from './steps/NccShareReview'
import { NccShareStart } from './steps/NccShareStart'

export type FormRefProps = {
  form: HTMLElement
  isValid: boolean
}

type NccShareModalStepConfig = {
  [key in NccShareSteps]: {
    title: string
    subtitle?: string
    primaryButtonText?: string
    secondaryButtonText?: string
    renderContent:
      | JSX.Element
      | ((formRef: React.MutableRefObject<FormRefProps>) => JSX.Element)
    hasFormRef?: boolean
  }
}

export enum NccShareSteps {
  Start,
  Review,
  Complete,
}

export const nccShareModalStepConfig: NccShareModalStepConfig = {
  [NccShareSteps.Start]: {
    title: i18n.t(i18nKeys.backgroundCheckShare__nccStart__title),
    primaryButtonText: i18n.t(
      i18nKeys.backgroundCheckShare__nccStart__primaryButtonText
    ),
    secondaryButtonText:
      isMobile &&
      i18n.t(i18nKeys.backgroundCheckShare__nccStart__secondaryButtonText),
    renderContent: <NccShareStart />,
  },
  [NccShareSteps.Review]: {
    title: i18n.t(i18nKeys.backgroundCheckShare__nccReview__title),
    primaryButtonText: i18n.t(
      i18nKeys.backgroundCheckShare__nccReview__primaryButtonText
    ),
    secondaryButtonText: i18n.t(
      i18nKeys.backgroundCheckShare__nccReview__secondaryButtonText
    ),
    renderContent: formRef => <NccShareReview formRef={formRef} />,
    hasFormRef: true,
  },
  [NccShareSteps.Complete]: {
    title: i18n.t(i18nKeys.backgroundCheckShare__nccComplete__title),
    primaryButtonText: i18n.t(
      i18nKeys.backgroundCheckShare__nccComplete__primaryButtonText
    ),
    renderContent: <NccShareComplete />,
  },
}
